import { deleteReq } from '../../utils/request'

// Trvale zmazanie tranzakcie - backend zaznam odstrani natrvalo a prepocita stavy skladu.
const deleteStoreItemTransaction = async (id: number) => {
	const { data } = await deleteReq(`/api/admin/store-item-transactions/${id}`)
	return data
}

export default deleteStoreItemTransaction
